module.exports = __webpack_public_path__ + "static/media/slideshow (11).09fecb93.png";